import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "@/design/tokens.stylex";
import { colors, space, text } from "@/design/tokens.stylex";
import Button from "./Button";
import Modal from "./Modal";

// A small Modal that asks before something happens: what will happen, then
// Cancel and the action. Cancel takes focus, so Enter never confirms by accident.

export interface ConfirmDialogProps {
  open: boolean;
  title: string;
  /** What will happen, in plain words. */
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  // Extra content between the message and the buttons, e.g. a typed confirmation.
  children?: ReactNode;
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}
export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Delete",
  cancelLabel = "Cancel",
  destructive = false,
  children,
  confirmDisabled = false,
  onConfirm,
  onCancel
}: ConfirmDialogProps) {
  if (!open) return null;
  return <Modal title={title} size="sm" onClose={onCancel} footer={<>
          {/* Extra content (a typed confirmation) focuses its own field. */}
          <Button variant="ghost" autoFocus={!children} onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant={destructive ? "danger" : "primary"} disabled={confirmDisabled} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>}>
      <div className="xtu3avg x1e3avs9">{message}</div>
      {children && <div className="x11j7w4t">{children}</div>}
    </Modal>;
}